import { ClientWorkflow } from "@avenueops/shared-types";
import { Badge } from "@avenueops/web-components";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { WorkflowAlertingConditions, WorkflowTriggerType } from "@prisma/client";
import Link from "next/link";
import { pagesPath } from "utils/$path";
import { humanizeIntegrationWebhookTriggerEvent } from "utils/workflows";

interface Props {
  workflow: ClientWorkflow;
  size?: "SMALL" | "MEDIUM" | "LARGE";
}

export function MonitorTypeTag({ workflow, size = "SMALL" }: Props) {
  return (
    <div className="text-sm font-medium select-none">
      {workflow.triggerType === WorkflowTriggerType.WEBHOOK && workflow.formTemplateId ? (
        <Link href={pagesPath.forms.builder._id(workflow.formTemplateId).$url()}>
          <Badge size={size} type="CUSTOM" className="bg-purple-100 text-purple-800 flex flex-row gap-1">
            <div>Form</div>
            <ArrowTopRightOnSquareIcon className="w-4 h-4" />
          </Badge>
        </Link>
      ) : workflow.triggerType === WorkflowTriggerType.WEBHOOK ? (
        <Badge size={size} type="CUSTOM" className="bg-primary-light text-gray-800">
          Webhook
        </Badge>
      ) : workflow.triggerType === WorkflowTriggerType.INTEGRATION ? (
        <Badge type="CUSTOM" size={size} className="bg-teal-100 text-teal-800">
          {humanizeIntegrationWebhookTriggerEvent(workflow)}
        </Badge>
      ) : workflow.alertingConditions === WorkflowAlertingConditions.NEW_ROW ? (
        <Badge type="CUSTOM" size={size} className="bg-sky-100 text-sky-800">
          Event
        </Badge>
      ) : workflow.alertingConditions === WorkflowAlertingConditions.PASSTHROUGH ? (
        <Badge type="CUSTOM" size={size} className="bg-yellow-100 text-yellow-800">
          Report
        </Badge>
      ) : (
        <Badge type="CUSTOM" size={size} className="bg-indigo-100 text-indigo-800">
          Metric
        </Badge>
      )}
    </div>
  );
}
